import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../../base/components/Header';
import { useAppDispatch, useAppSelector, useBrowserBackClickHandler } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { LoginData } from '../../components/CreateLogin/LoginData';
import { Confirmation } from '../../components/CreateLogin/Confirmation';
import { CreateLoginStep } from '../../enums';
import { settingsActions } from '../../redux/slice/settingsSlice';
import { Helmet } from '../../../../components/Helmet';

export const CreateLoginPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const {
        createLogin: { step },
    } = useAppSelector((state) => state.workerAppSettings);
    const { referrer } = useAppSelector((state) => state.app);

    const [savedReferrerLocation, setSavedReferrerLocation] = useState('');

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });

        return function () {
            dispatch(settingsActions.clearData());
        };
    }, []);

    useEffect(() => {
        if (location.state?.from?.pathname) {
            setSavedReferrerLocation(location.state.from.pathname);
        }
    }, [location]);

    const onBackClick = useCallback(() => {
        if (step === CreateLoginStep.LoginData) {
            if (savedReferrerLocation) {
                navigate(savedReferrerLocation);
                return;
            }
            if (referrer) {
                window.location.href = referrer;
                return;
            }
        }

        dispatch(settingsActions.setCreateLoginStep(step - 1));
    }, [step, referrer, savedReferrerLocation]);

    useBrowserBackClickHandler(onBackClick);

    const content = useMemo(() => {
        switch (step) {
            case CreateLoginStep.LoginData:
                return <LoginData />;
            case CreateLoginStep.Confirmation:
                return <Confirmation />;
        }
    }, [step]);

    return (
        <>
            <Helmet pageName={__t('Создание логина и пароля')} />
            <div className='login-create-page'>
                <Header title={__t('Создание логина и пароля')} onBackClick={onBackClick} />
                {content}
            </div>
        </>
    );
};
